import { fetchAllPages } from "../util/wpapi_util";

export const resolves = store => {
  return [
    {
      path: '',
      resolve: [
        {
          id: 'solutions',
          data: () => store.getState().WPAPI.instance
            .product_categories()
            .param("parent",0)
            .perPage(100)
            .get()
            .then(response => {
              return Promise.resolve(response
                .sort((a ,b) => a.acf.index < b.acf.index ? -1 : ( a.acf.index > b.acf.index ? 1 : 0 ))
              );
            })
        },
        {
          id: 'post_categories',
          data: () => {
            const apiCall = store.getState().WPAPI.instance
              .categories()
              .perPage(100);

            return fetchAllPages(apiCall);
          }
        },
        {
          id: 'news_list',
          data: () => {
            return store.getState().WPAPI.instance
              .news()
              .perPage(10)
              .then( response => {
                const categories = store.getState().resolve.data.post_categories;

                const news = response.map( news => {
                  news.categories = news.categories
                    .map( id => categories.find( category => category.id === id ));
                  return news;
                });

                news._paging = response._paging;

                return Promise.resolve(news);
              });
          }
        },
      ],
      async: false,
      children: [
        {
          path: '',
          resolve: [
            {
              id: 'homePage',
              data: () => store.getState().WPAPI.instance
                .pages()
                .id(813)
                .embed()
                .then( response => {
                  try {
                    if(typeof response.acf.case_story[0] === 'number'){
                      return store.getState().WPAPI.instance
                        .news()
                        .id(response.acf.case_story[0])
                        .then( featuredCaseStory => {
                          response.featuredCaseStory = featuredCaseStory;
                          return Promise.resolve(response);
                        })
                    }
                  } catch(e){
                    return Promise.resolve(response);
                  }
                })
            },
            {
              id: 'contact_us_section',
              data: () => store.getState().WPAPI.instance
                .pages()
                .id(1140)
                .embed()
                .get()
            },
            {
              id: 'newest_case_story',
              data: () => store.getState().WPAPI.instance
                .posts()
                .param("categories", 59)
                .perPage(1)
                .embed()
                .get()
            },
            {
              id: 'footer',
              data: () => store.getState().WPAPI.instance
                .pages()
                .slug('footer')
                .then( response => {
                  let o = null;

                  if(Array.isArray(response))
                    o = response[0];

                  return Promise.resolve(o);
                })
            }
          ],
          async: true,
          children: [
            {
              path: "solutions",
              resolve: [
                {
                  id: 'solutionsPage',
                  data: () => store.getState().WPAPI.instance
                    .pages()
                    .id(805)
                    .embed()
                    .get()
                }
              ],
              children: [
                {
                  path: ":solution_slug",
                  resolve: [
                    {
                      id: 'solution_categories',
                      data: params => {
                        const solution = store.getState()
                          .resolve
                          .data
                          .solutions
                          .find(solution => solution.slug === params.solution_slug);

                        if(!solution){
                          return Promise.reject(new Error(404));
                        }

                        return store.getState().WPAPI.instance
                          .product_categories()
                          .param("parent", solution.id)
                          .perPage(100)
                          .get()
                          .then(response => {
                            return Promise.resolve(response
                              .sort((a ,b) => a.acf.index < b.acf.index ? -1 : ( a.acf.index > b.acf.index ? 1 : 0 ))
                            );
                          })
                      }
                    },
                    {
                      id: 'solution_products',
                      data: params => {
                        const solution = store.getState()
                          .resolve
                          .data
                          .solutions
                          .find(solution => solution.slug === params.solution_slug);

                        if (!solution)
                          return Promise.resolve();

                        const apiCall = store.getState().WPAPI.instance
                          .products()
                          .embed()
                          .param("product_categories", [solution.id])
                          .perPage(100);

                        return fetchAllPages(apiCall);
                      }
                    }
                  ],
                  async: false,
                  children: [
                    {
                      path: "products/:product_slug",
                      resolve: [
                        {
                          id: 'product',
                          data: params => {
                            const product = store.getState()
                              .resolve
                              .data
                              .solution_products
                              .find(product => product.slug === params.product_slug);

                            if(!product){
                              return Promise.reject(new Error(404));
                            }

                            return Promise.resolve(product);

                          }
                        }
                      ],
                      async: false,
                    }
                  ]
                },
              ]
            },
            {
              "path": "news",
              children: [
                {
                  "path": ":news_slug",
                  resolve: [
                    {
                      id: 'news_story',
                      data: params => {
                        return store.getState().WPAPI.instance
                          .news()
                          .slug(params.news_slug)
                          .then( response => {
                            if(response.length === 0){
                              throw new Error(404);
                            }
                            return Promise.resolve(response);
                          });
                      }
                    }
                  ]
                }
              ]
            },
            {
              "path": "contact",
              resolve: [
                {
                  id: 'contacts',
                  data: () => store.getState().WPAPI.instance
                    .contacts()
                    .embed()
                    .perPage(100)
                    .get()
                },
                {
                  id: 'contact_categories',
                  data: () => store.getState().WPAPI.instance
                    .contact_categories()
                    .perPage(100)
                    .get()
                }
              ]
            },
            {
              "path": "about",
              resolve: [
                {
                  id: 'aboutPage',
                  data: () => store.getState().WPAPI.instance
                    .pages()
                    .id(807)
                    .embed()
                    .get()
                }
              ]
            },
            {
              "path": "support",
              resolve: [
                {
                  id: 'supportPage',
                  data: () => store.getState().WPAPI.instance
                    .pages()
                    .id(809)
                    .embed()
                    .get()
                }
              ]
            },
            {
              "path": "contact",
              resolve: [
                {
                  id: 'contactPage',
                  data: () => store.getState().WPAPI.instance
                    .pages()
                    .id(811)
                    .embed()
                    .get()
                }
              ]
            }
          ]
        }
      ]
    }
  ];
};



// WEBPACK FOOTER //
// ./src/config/resolve.js